import { render, staticRenderFns } from "./selected-modal.vue?vue&type=template&id=8d7a7326&scoped=true&"
import script from "./selected-modal.vue?vue&type=script&lang=js&"
export * from "./selected-modal.vue?vue&type=script&lang=js&"
import style0 from "./selected-modal.vue?vue&type=style&index=0&id=8d7a7326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7a7326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
